<template>
	<div class="date-picker">

		<!--<Datepicker
			ref="datepicker"
			class="h-100"
			type="text"
			typeable
			:format="formatDate"
			:placeholder="placeholder"
			:monday-first="true"
			:language="es"
			input-class="vue-comp-datepicker w-100 h-100 bg-transparent"
			wrapper-class="w-100 h-100"
			v-model="model"
			@closed="save"
		/>-->

		<el-date-picker
			ref="datepicker"
			v-model="model"
			type="date"
			size="mini"
			:placeholder="placeholder"
			:clearable="false"
			format="dd/MM/yyyy"
			:picker-options="pickerOptions"
			@closed="save">
		</el-date-picker>

	</div>
</template>

<script>
	//import Datepicker from 'vuejs-datepicker'
	//import { es } from 'vuejs-datepicker/dist/locale'
	import moment from 'moment'

	export default {

		name: 'DatePicker',
		props: {
			placeholder: String,
			formatDate: Function,
			inputClass: Array,
			value: String,
			outputFormat: String,
			active: Boolean,
			dateFormat: String
		},
		components: {
			//Datepicker
		},
		data () {
			return {
				// es: es,
				model: '',
				pickerOptions: {
					firstDayOfWeek: 1
				}
			}
		},
		watch: {
			model (val) {
				
				this.$emit('input', moment(new Date(val)).format(this.dateFormat))

			},
			active (val) {

				if (val) return

				if (this.$refs.datepicker.isOpen) this.$refs.datepicker.showCalendar()

			}
		},
		created () {

			this.model = this.value

		},
		methods: {
			save () {
				
				this.$emit('input', moment(new Date(this.model)).format(this.dateFormat))

			},
			focus () {

				if (this.$refs.datepicker.isOpen) return
				console.log('focus')
				this.$refs.datepicker.showCalendar()

			}
		}
	}
</script>

<style lang="scss">

	/*.vdp-datepicker > div {
		height: 100%;
	}

	.vdp-datepicker__calendar > div {
		background-color: white;
		right: 0;
		border: 1px solid #ccc;
	}*/

</style>
